import { Phone } from "lucide-react";

/**
 * Sticky mobile-only "Call Now" floating button.
 * Positioned bottom-LEFT so it doesn't collide with the ChatWidget (bottom-right).
 */
export default function MobileCallButton() {
    return (
        <a
            href="tel:+353838798812"
            data-testid="mobile-call-btn"
            aria-label="Call Signature Shine & Co."
            className="md:hidden fixed bottom-6 left-6 z-40 inline-flex items-center gap-2 bg-gold text-navy px-4 py-3 rounded-full shadow-[0_6px_20px_rgba(212,175,55,0.55)] font-outfit font-semibold text-sm uppercase tracking-wider hover:bg-gold-light transition-colors"
        >
            <Phone className="w-4 h-4" />
            Call now
        </a>
    );
}
